(() => {
  class NovaHeroController {
    constructor(root) {
      this.root = root;
      if (this.events) return;
      this.events = new AbortController();
      const signal = this.events.signal;
      this.slides = [...this.root.querySelectorAll('.swiper-slide')];
      if (!this.slides.length) return;
      this.index = 0;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.delay = Number(JSON.parse(this.root.querySelector('[data-slider-options]').dataset.sliderOptions).auto_play) * 1000;
      this.playing = this.delay > 0 && !this.motion.matches;
      this.root.querySelector('.swiper').classList.add('swiper-initialized', 'nova-native-hero');
      const pagination = this.root.querySelector('.swiper-pagination');
      this.buttons = this.slides.map((slide, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'swiper-pagination-bullet';
        button.setAttribute('aria-label', 'Go to slide ' + (index + 1));
        button.addEventListener('click', () => { this.stop(); this.show(index); }, { signal });
        pagination?.append(button);
        return button;
      });
      this.root.addEventListener('focusin', () => this.stop(), { signal });
      this.root.addEventListener('pointerenter', event => {
        if (event.pointerType !== 'mouse') return;
        this.hovered = true;
        this.schedule();
      }, { signal });
      this.root.addEventListener('pointerleave', event => {
        if (event.pointerType !== 'mouse') return;
        this.hovered = false;
        this.schedule();
      }, { signal });
      this.root.addEventListener('pointerdown', event => {
        this.pointer = { x: event.clientX, y: event.clientY };
        this.slides.forEach(slide => this.hydrate(slide));
      }, { signal, passive: true });
      this.root.addEventListener('pointerup', event => {
        if (!this.pointer) return;
        const dx = event.clientX - this.pointer.x;
        const dy = event.clientY - this.pointer.y;
        this.pointer = null;
        if (Math.abs(dx) < 45 || Math.abs(dx) <= Math.abs(dy)) return;
        this.blockClickUntil = performance.now() + 400;
        this.stop();
        this.show(this.index + (dx < 0 ? 1 : -1));
      }, { signal, passive: true });
      this.root.addEventListener('pointercancel', () => { this.pointer = null; }, { signal });
      this.root.addEventListener('click', event => {
        if (performance.now() >= (this.blockClickUntil || 0)) return;
        event.preventDefault();
        event.stopImmediatePropagation();
      }, { signal, capture: true });
      this.root.addEventListener('keydown', event => {
        if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        this.stop();
        this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1));
      }, { signal });
      this.motion.addEventListener('change', () => { if (this.motion.matches) this.stop(); }, { signal });
      document.addEventListener('visibilitychange', () => this.schedule(), { signal });
      this.show(0);
    }

    hydrate(slide) {
      slide.querySelectorAll('template[data-nova-hero-image]').forEach(template => template.replaceWith(template.content.cloneNode(true)));
    }

    show(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.hydrate(this.slides[this.index]);
      this.slides.forEach((slide, position) => {
        const active = position === this.index;
        slide.classList.toggle('swiper-slide-active', active);
        slide.toggleAttribute('inert', !active);
        slide.setAttribute('aria-hidden', String(!active));
        this.buttons[position].classList.toggle('swiper-pagination-bullet-active', active);
        this.buttons[position].setAttribute('aria-current', String(active));
      });
      this.schedule();
    }

    stop() {
      this.playing = false;
      this.schedule();
    }

    schedule() {
      clearTimeout(this.timer);
      clearTimeout(this.imageTimer);
      if (!this.playing || this.hovered || document.hidden) return;
      const delay = Number(this.slides[this.index].dataset.swiperAutoplay) || this.delay;
      this.imageTimer = setTimeout(() => this.hydrate(this.slides[(this.index + 1) % this.slides.length]), Math.max(0, delay - 2000));
      this.timer = setTimeout(() => this.show(this.index + 1), delay);
    }

    disconnect() {
      clearTimeout(this.timer);
      clearTimeout(this.imageTimer);
      this.events?.abort();
      this.events = null;
      this.root.querySelector('.swiper-pagination')?.replaceChildren();
    }
  }
  const instances = new WeakMap();
  const init = scope => scope.querySelectorAll('slideshow-component[data-nova-native-hero]').forEach(root => {
    if (!instances.has(root)) instances.set(root, new NovaHeroController(root));
  });
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('slideshow-component[data-nova-native-hero]').forEach(root => {
      instances.get(root)?.disconnect();
      instances.delete(root);
    });
  });
})();
